export default [
    // packages ordered by priority
    "PFPCS",
    "PFTT",
    "PFP",
    "PFCS",
    "PF",
    "PMA",
    "HS",
    "PFTTF",
    "PFPTTF",
];
